import React, { type ReactElement } from "react";

import clsx from "clsx";

import googleAdsLogoV2 from "@assets/ga-logo-v2.svg";
import youtubeLogoV2 from "@assets/yt-logo-v2.svg";
import { useDesignElementManager } from "@hooks/use-design-element-manager";

export function FBIcon({ className }: { className?: string }) {
  return (
    <div
      className={clsx(
        "w-6 h-6 bg-facebook-icon rounded-full justify-center flex items-center",
        className,
      )}
    >
      <i className="fa-brands text-[#3B5998] text-sm fa-facebook-f"></i>
    </div>
  );
}

export function PinterestIcon({ className }: { className?: string }) {
  return (
    <div
      className={clsx(
        "w-6 h-6 bg-pinterest-icon rounded-full justify-center flex items-center",
        className,
      )}
    >
      <i className="fa-brands text-white text-sm fa-pinterest-p"></i>
    </div>
  );
}

export function GoogleIcon({ className }: { className?: string }) {
  return (
    <div className={clsx("w-6 h-6 rounded-full", className)}>
      <img className="img-fluid" src={googleAdsLogoV2} alt="Google ads logo" />
    </div>
  );
}

export function YoutubeIcon({ className }: { className?: string }) {
  return (
    <div className={clsx("w-6 h-6 rounded-full", className)}>
      <img className="img-fluid" src={youtubeLogoV2} alt="Youtube logo" />
    </div>
  );
}

export function InstagramIcon({ className }: { className?: string }) {
  return (
    <div
      className={clsx(
        "w-6 h-6 bg-instagram-icon rounded-full justify-center flex items-center",
        className,
      )}
    >
      <i className="fa-brands text-[#3B5998] text-sm fa-instagram"></i>
    </div>
  );
}

export function TikTokIcon({ className }: { className?: string }) {
  return (
    <div
      className={clsx(
        "w-6 h-6 bg-tiktok-icon rounded-full justify-center flex items-center",
        className,
      )}
    >
      <i className="fa-brands text-[#021230] text-sm fa-tiktok"></i>
    </div>
  );
}

export function SnapchatIcon({ className }: { className?: string }) {
  return (
    <div
      className={clsx(
        "w-6 h-6 bg-snapchat-icon rounded-full justify-center flex items-center",
        className,
      )}
    >
      <i className="fa-brands text-[#3B5998] text-sm fa-snapchat"></i>
    </div>
  );
}

export function AppLovinIcon({ className }: { className?: string }) {
  const { designElementManager } = useDesignElementManager();
  const icon: ReactElement = designElementManager
    .getDesignElement("applovin")
    .getComponent();

  return (
    <div
      className={clsx(
        "w-6 h-6 bg-snapchat-icon rounded-full justify-center flex items-center",
        className,
      )}
    >
      {icon}
    </div>
  );
}

export function PlusMoreIcon({
  className,
  amountMore,
}: {
  className?: string;
  amountMore: number;
}) {
  return (
    <div
      className={clsx(
        "w-6 h-6 bg-snapchat-icon rounded-full justify-center flex items-center",
        className,
      )}
    >
      +{amountMore}
    </div>
  );
}
